@if (serie.isVisible) {
  <svg:g>
    @for (circle of serie.dataPoints; track keyAccessor($index, circle)) {
      <svg:g>
        @if (this.serie.drawNullPoint || this.serie.yAccessor(circle)) {
          <svg:circle
            [style.stroke]="serie.config.color"
            [attr.cx]="serie.xAccessorScaled(circle)"
            [attr.cy]="serie.yAccessorScaled(circle)"
            [attr.r]="radius">
            <!-- <animate
            attributeName="cy"
            attributeType="XML"
            [attr.from]="serie.y0AccessorScaled(circle)"
            [attr.to]="serie.yAccessorScaled(circle)"
            begin="0s"
            dur="1s"
            fill="freeze"
            /> -->
            </svg:circle>
          }
          </svg:g>
        }
        </svg:g>
      }
